import { authAxios as axios } from "shared-auth";

import { IPerformersList, ISearchFilters } from "shared/models/Performers";

import config from "config/global";

class PerformerService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async searchPerformers(
    searchBody: ISearchFilters,
    abortController?: AbortController
  ): Promise<IPerformersList> {
    try {
      const response = await axios(`${this.url}/search`, {
        method: "post",
        data: searchBody,
        signal: abortController?.signal,
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default new PerformerService({
  url: config.searchApi || config.searchAndFiltersApiUrl,
});
